<template>
  <v-dialog
    :value="update.visible"
    @input="onDialogInput"
    :persistent="update.forceUpdate"
    max-width="460"
    content-class="mobile-app-update-dialog"
    aria-labelledby="mobile-app-update-title"
  >
    <v-card class="mobile-app-update-dialog__card">
      <v-card-title id="mobile-app-update-title" class="mobile-app-update-dialog__header">
        <v-icon color="primary" class="mr-3" aria-hidden="true">mdi-cellphone-arrow-down</v-icon>
        Update available
      </v-card-title>
      <v-card-text class="mobile-app-update-dialog__body">
        <p class="mb-2">
          {{ update.forceUpdate
            ? `${brandName} must be updated before you can continue.`
            : `A newer version of ${brandName} is ready to install.` }}
        </p>
        <p class="admin-muted mb-0">Version {{ update.latestVersion }}</p>
      </v-card-text>
      <v-card-actions class="mobile-app-update-dialog__actions">
        <v-btn v-if="!update.forceUpdate" text color="primary" @click="later">Later</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :href="update.storeUrl"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="`Update ${brandName} from the app store`"
        >
          Update
          <v-icon right aria-hidden="true">mdi-open-in-new</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { dismissMobileAppUpdate, mobileAppUpdate } from "./appUpdate";
import { mobileBrand } from "./brand";

export default {
  name: "MobileAppUpdateDialog",
  computed: {
    update() { return mobileAppUpdate; },
    brandName() { return mobileBrand.name; },
  },
  methods: {
    later() { dismissMobileAppUpdate(); },
    onDialogInput(visible) {
      if (!visible && !this.update.forceUpdate) dismissMobileAppUpdate();
    },
  },
};
</script>

<style scoped>
.mobile-app-update-dialog__card { display: flex; flex-direction: column; max-height: min(80vh, 560px); overflow: hidden; }
.mobile-app-update-dialog__header { border-bottom: 1px solid rgba(0, 0, 0, 0.12); flex: 0 0 auto; }
.theme--dark .mobile-app-update-dialog__header { border-bottom-color: rgba(255, 255, 255, 0.16); }
.mobile-app-update-dialog__body { min-height: 0; overflow-y: auto; padding: 24px; }
.mobile-app-update-dialog__actions { border-top: 1px solid rgba(0, 0, 0, 0.12); flex: 0 0 auto; padding: 12px 16px calc(12px + env(safe-area-inset-bottom)); }
.theme--dark .mobile-app-update-dialog__actions { border-top-color: rgba(255, 255, 255, 0.16); }
</style>
